import i18n from "@/features/i18n/config";
import { useUserPrivateSettings } from "@/hooks/useUserPrivateSettings";
import { useAuth } from "@/hooks/useAuth";
import { useEffect, useRef } from "react";

/**
 * Wendet die in user_private.settings gespeicherte Sprache an, sobald der
 * Nutzer eingeloggt ist (z. B. auf neuem Gerät). Läuft nur im Hintergrund,
 * keine UI – State of the Art: gespeicherte Sprache wird beim Login übernommen.
 */
export function useUserLanguageSync(): void {
  const { user } = useAuth();
  const { data: settings } = useUserPrivateSettings(user?.id);
  const appliedForUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!user?.id || appliedForUserIdRef.current === user.id) return;
    if (!settings) return;

    appliedForUserIdRef.current = user.id;

    const lang = settings.language;
    if (lang === "de" || lang === "en") {
      const current = i18n.language || "de";
      const normalizedCurrent =
        current === "en" || current.startsWith("en") ? "en" : "de";
      if (normalizedCurrent !== lang) {
        void i18n.changeLanguage(lang);
      }
    }
  }, [user?.id, settings]);

  useEffect(() => {
    if (!user?.id) appliedForUserIdRef.current = null;
  }, [user?.id]);
}
